export default __webpack_public_path__ + "static/identity-validation-93001aaadb36ba9e7e706ab18c8179f5.webp";